{
    "name": "viguide-planning",
    "version": "2.44.0",
    "versions": {
        "viguide-planning": "2.43.0",
        "home-planner": "0.1.0",
        "planning-tools-config": "0.1.0"
    },
    "scripts": {
        "start": "yarn generate-apis:preview && nx serve viguide-planning",
        "start:hp": "nx serve home-planner",
        "start:ptc": "nx serve planning-tools-config",
        "serve:viguide-planning": "nx serve viguide-planning",
        "serve:home-planner": "nx serve home-planner",
        "serve:planning-tools-config": "nx serve planning-tools-config",
        "style:ca-components": "nx style ca-components",
        "style:home-planner-b2c": "nx style home-planner-b2c",
        "test:ca-components": "nx test ca-components",
        "test:home-planner-b2c": "yarn generate-apis:preview && nx test home-planner-b2c",
        "build:ca-components": "nx build ca-components",
        "build:home-planner-b2c": "yarn generate-apis:preview && nx build home-planner-b2c && nx build home-planner-elements",
        "version:home-planner-b2c": "nx version home-planner-b2c",
        "serve:viguide-planning:local": "yarn api:generate:preview && nx serve viguide-planning --configuration=local",
        "serve:viguide-planning:develop": "yarn api:generate:develop && nx serve viguide-planning --configuration=develop",
        "serve:viguide-planning:preview": "yarn api:generate:preview && nx serve viguide-planning --configuration=preview",
        "serve:viguide-planning:integration": "yarn api:generate:integration && nx serve viguide-planning --configuration=integration",
        "serve:viguide-planning:staging": "yarn api:generate:staging && nx serve viguide-planning --configuration=staging",
        "build:viguide-planning:integration": "yarn api:create:integration && nx build viguide-planning --configuration=integration",
        "build:viguide-planning:develop": "yarn api:create:develop && nx build viguide-planning --configuration=develop",
        "build:viguide-planning:preview": "yarn api:create:preview && nx build viguide-planning --configuration=preview",
        "build:viguide-planning:staging": "yarn api:create:staging && nx build viguide-planning --configuration=staging",
        "build:viguide-planning:production": "yarn api:create:production && nx build viguide-planning --configuration=production",
        "build:home-planner:development": "yarn create-apis:preview && nx build:development home-planner",
        "build:home-planner:develop": "yarn create-apis:develop && nx build:develop home-planner",
        "build:home-planner:preview": "yarn create-apis:preview && nx build:preview home-planner",
        "build:home-planner:integration": "yarn create-apis:integration && nx build:integration home-planner",
        "build:home-planner:staging": "yarn create-apis:staging && nx build:staging home-planner",
        "build:home-planner:production": "yarn create-apis:production && nx build:production home-planner",
        "build:planning-tools-config:development": "yarn create-apis:preview && nx build:development planning-tools-config",
        "build:planning-tools-config:integration": "yarn create-apis:integration && nx build:integration planning-tools-config",
        "build:planning-tools-config:develop": "yarn create-apis:develop && nx build:develop planning-tools-config",
        "build:planning-tools-config:preview": "yarn create-apis:preview && nx build:preview planning-tools-config",
        "build:planning-tools-config:staging": "yarn create-apis:staging && nx build:staging planning-tools-config",
        "build:planning-tools-config:production": "yarn create-apis:production && nx build:production planning-tools-config",
        "test:viguide-planning:integration": "yarn create-apis:integration && nx lint viguide-planning && nx run-many --target=test --projects=viguide-planning,shared-ui,shared-services,shared-utils",
        "test:viguide-planning:develop": "yarn create-apis:develop && nx lint viguide-planning && nx run-many --target=test --projects=viguide-planning,shared-ui,shared-services,shared-utils",
        "test:viguide-planning:preview": "yarn create-apis:preview && nx lint viguide-planning && nx run-many --target=test --projects=viguide-planning,shared-ui,shared-services,shared-utils",
        "test:viguide-planning:staging": "yarn create-apis:staging && nx lint viguide-planning && nx run-many --target=test --projects=viguide-planning,shared-ui,shared-services,shared-utils",
        "test:viguide-planning:production": "yarn create-apis:production && nx lint viguide-planning && nx run-many --target=test --projects=viguide-planning,shared-ui,shared-services,shared-utils",
        "test:viguide-planning": "nx run-many --target=test --projects=ca-components,viguide-planning,shared-ui,shared-services,shared-utils",
        "test:home-planner": "nx run-many --target=test --projects=home-planner-b2c,ca-components,home-planner,shared-ui,shared-services,shared-utils",
        "test": "yarn generate-apis:preview && nx run-many --target=test --projects=home-planner-b2c,ca-components,viguide-planning,home-planner,planning-tools-config,shared-ui,shared-services,shared-utils",
        "test:ci": "yarn create-apis:preview && nx run-many --target=test --projects=home-planner-b2c,ca-components,viguide-planning,home-planner,planning-tools-config,shared-ui,shared-services,shared-utils",
        "test:pre-push": "nx affected --target=test --exclude=mocks,shared-interfaces,shared-enums,home-planner-elements",
        "lint": "yarn generate-apis:preview && nx lint viguide-planning && nx lint home-planner",
        "lint:fix": "yarn generate-apis:preview && nx lint viguide-planning --fix && nx lint home-planner --fix",
        "prepare": "husky install",
        "postinstall": "yarn generate-apis:preview",
        "nx": "nx",
        "migrate": "nx migrate latest",
        "reset": "nx reset",
        "ci": "rm -rf node_modules && yarn install --frozen-lockfile",
        "e2e:viguide-planning": "cd apps/viguide-planning-e2e && npx playwright test --config config/playwright.config.ts",
        "e2e:viguide-planning:local": "cd apps/viguide-planning-e2e && npx playwright test --config config/local.config.ts",
        "e2e:viguide-planning:preview": "cd apps/viguide-planning-e2e && npx playwright test --config config/preview.config.ts",
        "e2e:viguide-planning:develop": "cd apps/viguide-planning-e2e && npx playwright test --config config/develop.config.ts",
        "e2e:viguide-planning:integration": "cd apps/viguide-planning-e2e && npx playwright test --config config/integration.config.ts",
        "e2e:viguide-planning:staging": "cd apps/viguide-planning-e2e && npx playwright test --config config/staging.config.ts",
        "e2e:viguide-planning:ui": "cd apps/viguide-planning-e2e && npx playwright test --ui --config config/playwright.config.ts",
        "e2e:viguide-planning:ui:local": "cd apps/viguide-planning-e2e && npx playwright test --ui --config config/local.config.ts",
        "e2e:viguide-planning:ui:preview": "cd apps/viguide-planning-e2e && npx playwright test --ui --config config/preview.config.ts",
        "e2e:viguide-planning:ui:develop": "cd apps/viguide-planning-e2e && npx playwright test --ui --config config/develop.config.ts",
        "e2e:viguide-planning:ui:integration": "cd apps/viguide-planning-e2e && npx playwright test --ui --config config/integration.config.ts",
        "e2e:viguide-planning:ui:staging": "cd apps/viguide-planning-e2e && npx playwright test --ui --config config/staging.config.ts",
        "e2e:report:viguide-planning": "cd apps/viguide-planning-e2e && npx playwright show-report --config config/playwright.config.ts",
        "e2e:report:viguide-planning:local": "cd apps/viguide-planning-e2e && npx playwright show-report --config config/local.config.ts",
        "e2e:report:viguide-planning:preview": "cd apps/viguide-planning-e2e && npx playwright show-report --config config/preview.config.ts",
        "e2e:report:viguide-planning:develop": "cd apps/viguide-planning-e2e && npx playwright show-report --config config/develop.config.ts",
        "e2e:report:viguide-planning:integration": "cd apps/viguide-planning-e2e && npx playwright show-report --config config/integration.config.ts",
        "e2e:report:viguide-planning:staging": "cd apps/viguide-planning-e2e && npx playwright show-report --config config/staging.config.ts",
        "e2e:home-planner": "cd apps/home-planner-e2e && npx playwright test --config config/playwright.config.ts",
        "e2e:home-planner:local": "cd apps/home-planner-e2e && npx playwright test --config config/local.config.ts",
        "e2e:home-planner:integration": "cd apps/home-planner-e2e && npx playwright test --config config/integration.config.ts",
        "e2e:home-planner:staging": "cd apps/home-planner-e2e && npx playwright test --config config/staging.config.ts",
        "e2e:home-planner:ui": "cd apps/home-planner-e2e && npx playwright test --ui --config config/playwright.config.ts",
        "e2e:home-planner:ui:local": "cd apps/home-planner-e2e && npx playwright test --ui --config config/local.config.ts",
        "e2e:home-planner:ui:integration": "cd apps/home-planner-e2e && npx playwright test --ui --config config/integration.config.ts",
        "e2e:home-planner:ui:staging": "cd apps/home-planner-e2e && npx playwright test --ui --config config/staging.config.ts",
        "e2e:report:home-planner": "cd apps/home-planner-e2e && npx playwright show-report --config config/playwright.config.ts",
        "e2e:report:home-planner:local": "cd apps/home-planner-e2e && npx playwright show-report --config config/local.config.ts",
        "e2e:report:home-planner:integration": "cd apps/home-planner-e2e && npx playwright show-report --config config/integration.config.ts",
        "e2e:report:home-planner:staging": "cd apps/home-planner-e2e && npx playwright show-report --config config/staging.config.ts",
        "clear:api-planning-projects": "rm -rf libs/api-planning-projects/src/lib",
        "clear:api-planning-projects-v2": "rm -rf libs/api-planning-projects-v2/src/lib",
        "api:fetch:integration": "node scripts/fetch-api.js --configuration integration",
        "api:fetch:develop": "node scripts/fetch-api.js --configuration develop",
        "api:fetch:preview": "node scripts/fetch-api.js --configuration preview",
        "api:fetch:staging": "node scripts/fetch-api.js --configuration staging",
        "api:fetch:production": "node scripts/fetch-api.js --configuration production",
        "api:generate:integration": "yarn clear:api-planning-projects && ng-openapi-gen --input openapi/api-planning-projects-integration.swagger.json --output libs/api-planning-projects/src/lib",
        "api:generate:develop": "yarn clear:api-planning-projects && ng-openapi-gen --input openapi/api-planning-projects-develop.swagger.json --output libs/api-planning-projects/src/lib",
        "api:generate:preview": "yarn clear:api-planning-projects && ng-openapi-gen --input openapi/api-planning-projects-preview.swagger.json --output libs/api-planning-projects/src/lib",
        "api:generate:staging": "yarn clear:api-planning-projects && ng-openapi-gen --input openapi/api-planning-projects-staging.swagger.json --output libs/api-planning-projects/src/lib",
        "api:generate:production": "yarn clear:api-planning-projects && ng-openapi-gen --input openapi/api-planning-projects-production.swagger.json --output libs/api-planning-projects/src/lib",
        "api:create:integration": "yarn api:fetch:integration && yarn api:generate:integration",
        "api:create:develop": "yarn api:fetch:develop && yarn api:generate:develop",
        "api:create:preview": "yarn api:fetch:preview && yarn api:generate:preview",
        "api:create:staging": "yarn api:fetch:staging && yarn api:generate:staging",
        "api:create:production": "yarn api:fetch:production && yarn api:generate:production",
        "api:v2:fetch:integration": "node scripts/fetch-api.js --apiVersion v2 --configuration integration",
        "api:v2:fetch:develop": "node scripts/fetch-api.js --apiVersion v2 --configuration develop",
        "api:v2:fetch:preview": "node scripts/fetch-api.js --apiVersion v2 --configuration preview",
        "api:v2:fetch:staging": "node scripts/fetch-api.js --apiVersion v2 --configuration staging",
        "api:v2:fetch:production": "node scripts/fetch-api.js --apiVersion v2 --configuration production",
        "api:v2:generate:integration": "yarn clear:api-planning-projects-v2 && ng-openapi-gen --input openapi/api-planning-projects-v2-integration.swagger.json --output libs/api-planning-projects-v2/src/lib",
        "api:v2:generate:develop": "yarn clear:api-planning-projects-v2 && ng-openapi-gen --input openapi/api-planning-projects-v2-develop.swagger.json --output libs/api-planning-projects-v2/src/lib",
        "api:v2:generate:preview": "yarn clear:api-planning-projects-v2 && ng-openapi-gen --input openapi/api-planning-projects-v2-preview.swagger.json --output libs/api-planning-projects-v2/src/lib",
        "api:v2:generate:staging": "yarn clear:api-planning-projects-v2 && ng-openapi-gen --input openapi/api-planning-projects-v2-staging.swagger.json --output libs/api-planning-projects-v2/src/lib",
        "api:v2:generate:production": "yarn clear:api-planning-projects-v2 && ng-openapi-gen --input openapi/api-planning-projects-v2-production.swagger.json --output libs/api-planning-projects-v2/src/lib",
        "api:v2:create:integration": "yarn api:v2:fetch:integration && yarn api:v2:generate:integration",
        "api:v2:create:develop": "yarn api:v2:fetch:develop && yarn api:v2:generate:develop",
        "api:v2:create:preview": "yarn api:v2:fetch:preview && yarn api:v2:generate:preview",
        "api:v2:create:staging": "yarn api:v2:fetch:staging && yarn api:v2:generate:staging",
        "api:v2:create:production": "yarn api:v2:fetch:production && yarn api:v2:generate:production",
        "git:list-branch-commits": "node scripts/list-branch-commits.js",
        "generate-apis:preview": "yarn api:generate:preview && yarn api:v2:generate:preview",
        "create-apis:preview": "yarn api:create:preview && yarn api:v2:create:preview",
        "create-apis:integration": "yarn api:create:integration && yarn api:v2:create:integration",
        "create-apis:develop": "yarn api:create:develop && yarn api:v2:create:develop",
        "create-apis:staging": "yarn api:create:staging && yarn api:v2:create:staging",
        "create-apis:production": "yarn api:create:production && yarn api:v2:create:production"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "21.2.9",
        "@angular/cdk": "21.2.9",
        "@angular/common": "21.2.9",
        "@angular/compiler": "21.2.9",
        "@angular/core": "21.2.9",
        "@angular/elements": "21.2.9",
        "@angular/forms": "21.2.9",
        "@angular/material": "21.2.9",
        "@angular/platform-browser": "21.2.9",
        "@angular/platform-browser-dynamic": "21.2.9",
        "@angular/router": "21.2.9",
        "@angular/service-worker": "21.2.9",
        "@customer-apps/flexi-logic": "^2.0.4",
        "@customer-apps/flexi-paths": "^1.3.1",
        "@ngrx/effects": "21.0.0",
        "@ngrx/operators": "21.0.0",
        "@ngrx/store": "21.0.0",
        "@ngx-translate/core": "^16.0.4",
        "@ngx-translate/http-loader": "^16.0.1",
        "@nx/angular": "22.7.1",
        "@progress/kendo-angular-common": "20.1.1",
        "@progress/kendo-angular-pdf-export": "20.1.1",
        "@progress/kendo-drawing": "1.21.2",
        "@progress/kendo-licensing": "1.7.2",
        "@progress/kendo-theme-material": "^6.6.0",
        "@vi-succ/design-system-web": "1.4.3",
        "@vi-succ/vi-header-components": "^2.1.0",
        "@vi-succ/vi-header-domain": "^2.1.0",
        "@vi/global-header": "^15.3.3",
        "angular-oauth2-oidc": "^17.0.2",
        "autoprefixer": "^10.4.5",
        "chart.js": "4.4.4",
        "date-fns": "^3.6.0",
        "json-logic-js": "^2.0.5",
        "jsoneditor": "10.1.2",
        "lodash": "^4.17.21",
        "markdown-it": "14.1.0",
        "material-icons": "^1.13.1",
        "ng-openapi-gen": "^0.53.0",
        "ng2-charts": "10.0.0",
        "ngrx-store-localstorage": "20.0.0",
        "ngx-mask": "^15.1.0",
        "ngx-owl-carousel-o": "20.0.1",
        "ngx-translate-multi-http-loader": "19.0.3",
        "rxjs": "~7.8.0",
        "sass-loader": "^13.2.0",
        "scroll-behavior-polyfill": "^2.0.13",
        "tslib": "~2.5.0",
        "zone.js": "0.16.1"
    },
    "devDependencies": {
        "@angular-devkit/core": "21.2.9",
        "@angular-devkit/schematics": "21.2.9",
        "@angular-eslint/builder": "21.2.0",
        "@angular-eslint/eslint-plugin": "21.2.0",
        "@angular-eslint/eslint-plugin-template": "21.2.0",
        "@angular-eslint/schematics": "21.2.0",
        "@angular-eslint/template-parser": "21.2.0",
        "@angular/build": "21.2.9",
        "@angular/cli": "21.2.9",
        "@angular/compiler-cli": "21.2.9",
        "@angular/language-service": "21.2.9",
        "@auth0/angular-jwt": "^5.0.2",
        "@ngrx/store-devtools": "21.0.0",
        "@nx/esbuild": "22.7.1",
        "@nx/eslint-plugin": "22.7.1",
        "@nx/jest": "22.7.1",
        "@nx/js": "22.7.1",
        "@nx/workspace": "22.7.1",
        "@playwright/test": "^1.58.1",
        "@schematics/angular": "21.2.9",
        "@swc-node/register": "1.11.1",
        "@swc/core": "1.15.5",
        "@swc/helpers": "0.5.18",
        "@types/chart.js": "2.9.41",
        "@types/jasmine": "^4.0.3",
        "@types/jest": "^30.0.0",
        "@types/json-logic-js": "^2.0.7",
        "@types/jsoneditor": "9.9.5",
        "@types/lodash": "^4.14.182",
        "@types/markdown-it": "14.1.2",
        "@types/node": "^18.16.9",
        "@typescript-eslint/eslint-plugin": "^7.17.0",
        "@typescript-eslint/parser": "^7.17.0",
        "@typescript-eslint/utils": "^7.17.0",
        "baseline-browser-mapping": "^2.10.27",
        "deepmerge-ts": "5.1.0",
        "dotenv": "16.4.1",
        "esbuild": "^0.19.2",
        "eslint": "^8.53.0",
        "eslint-config-prettier": "9.1.2",
        "eslint-plugin-prettier": "5.5.4",
        "husky": "^8.0.0",
        "jasmine-core": "^4.1.1",
        "jasmine-marbles": "^0.9.2",
        "jest": "30.2.0",
        "jest-environment-jsdom": "30.2.0",
        "jest-environment-node": "30.2.0",
        "jest-preset-angular": "16.0.0",
        "jsonc-eslint-parser": "^2.1.0",
        "karma": "~6.4.1",
        "karma-chrome-launcher": "~3.1.1",
        "karma-coverage": "~2.1.0",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~1.7.0",
        "lint-staged": "^13.2.0",
        "ng-mocks": "14.14.0",
        "ng-packagr": "21.2.3",
        "nx": "22.7.1",
        "postcss": "^8.5.6",
        "postcss-cli": "^11.0.1",
        "postcss-scss": "^4.0.9",
        "postcss-url": "~10.1.3",
        "prettier": "3.3.3",
        "puppeteer": "^14.1.1",
        "stdin-discarder": "^0.3.2",
        "tailwindcss": "^3.4.1",
        "ts-jest": "29.4.5",
        "ts-node": "10.9.1",
        "typescript": "5.9.3"
    },
    "lint-staged": {
        "*.{html,js,jsx,ts,tsx,scss,less,css,json}": "prettier --write"
    }
}
